const { tablet } = require('./breakpoints');

const $ = require('jquery');

const videoPlaceholder = function () {
	if ($(window).width() < tablet) {
	   $(".js-video-play").click(function(){
			var $this = $(this),
				$videoPlaceholder = $this.closest('.video').find('.video-placeholder'),
				$videoPlayerIframe = $this.closest('.video').find('.video-iframe');

			if ($videoPlaceholder.outerWidth() < $(".container").outerWidth() / 2) {
				var $videoModalIframe = $("#videoModal").find(".video-iframe");
				$videoModalIframe.prop('src', $(this).data('src') + '&autoplay=1');
				$('#videoModal, html').addClass('is-active');
			} else  {
					$videoPlayerIframe.prop('src', $(this).data('src'));
					$this.addClass('is-hidden');
					$this.closest('.video').removeClass('has-placeholder');
					$videoPlaceholder.addClass('is-hidden');
					$videoPlayerIframe.prop('src', $videoPlayerIframe.prop('src') + '&autoplay=1').removeClass('is-hidden');
				}
			});

		$('.modal-close').on('click', function (e) {
		  	var $videoModalIframe = $("#videoModal").find(".video-iframe");
		  	$videoModalIframe.prop('src', '');
		  	$('#videoModal, html').removeClass('is-active');

		  	var $videoModalIframe = $("#modalVideo").find("iframe");
		  	$videoModalIframe.prop('src', '');
		});
	}
	else {
	   $(".js-video-play").click(function () {
			var $this = $(this),
				$videoPlaceholder = $this.closest('.video').find('.video-placeholder'),
				$videoPlayerIframe = $this.closest('.video').find('.video-iframe');

			$videoPlayerIframe.prop('src', $(this).data('src'));
			$this.addClass('is-hidden');
			$this.closest('.video').removeClass('has-placeholder');
			$videoPlaceholder.addClass('is-hidden');
			$videoPlayerIframe.prop('src', $videoPlayerIframe.prop('src') + '&autoplay=1').removeClass('is-hidden');
		});
	}
}

module.exports = videoPlaceholder;


